/* eslint-disable consistent-return */
// src/routes/index.js (o donde defines el router)
import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated, loginWithCurrentUrl } from '@/keycloak';

const routes = [
  { path: '/qr/:uuid', component: () => import('@/views/ActivePage.vue') }, // público
  { path: '/', component: () => import('@/views/HomePage.vue'), meta: { requiresAuth: true } }, // privado
  { path: '/:catchAll(.*)*', component: () => import('@/views/NotFoundPage.vue') },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to, from, next) => {
  const needAuth = !!to.meta.requiresAuth;
  const authed = isAuthenticated();
  console.debug('[guard] to=', to.fullPath, 'needAuth=', needAuth, 'authed=', authed);

  if (!needAuth) return next();

  if (authed) return next();

  console.debug('[guard] redirecting to Keycloak with current URL…');
  await loginWithCurrentUrl();
  // no llamar next() aquí; el navegador salta a KC
});

export default router;
